import request from './request'

/**
 * Google login
 * @param {string} idToken Google ID Token
 * @returns {Promise}
 */
export function googleLogin(idToken) {
  return request({
    url: '/api/google/auth',
    method: 'post',
    data: {
      id_token: idToken
    }
  })
}

/**
 * Verify Google ID Token
 * @param {string} idToken Google ID Token
 * @returns {Promise}
 */
export function verifyGoogleToken(idToken) {
  return request({
    url: '/api/google/verify',
    method: 'post',
    data: {
      id_token: idToken
    }
  })
}

/**
 * Get Google user information
 * @param {string} token User token
 * @returns {Promise}
 */
export function getGoogleUserInfo(token) {
  return request({
    url: '/api/google/user/info',
    method: 'get',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
}

/**
 * Refresh Google token
 * @param {string} refreshToken Refresh token
 * @returns {Promise}
 */
export function refreshGoogleToken(refreshToken) {
  return request({
    url: '/api/google/refresh',
    method: 'post',
    data: {
      refresh_token: refreshToken
    }
  })
}

/**
 * Check Google token validity
 * @param {string} token User token
 * @returns {Promise}
 */
export function checkGoogleToken(token) {
  return request({
    url: '/api/google/check',
    method: 'get',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
}

/**
 * Google login logout
 * @param {string} token User token
 * @returns {Promise}
 */
export function googleLogout(token) {
  return request({
    url: '/api/google/logout',
    method: 'post',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
}